export function computeProgress(objective) {
  let progress = 0;

  let totalWeight = objective.keyResults.reduce(
    (acc, keyResult) => acc + keyResult.weight,
    0,
  );

  if (totalWeight === 0) {
    return progress;
  }

  let completedWeight = objective.keyResults.reduce(
    (acc, keyResult) =>
      acc + (keyResult.status === "COMPLETED" ? keyResult.weight : 0),
    0,
  );

  progress = (completedWeight / totalWeight) * 100;

  return progress;
}
